import styled from '@emotion/styled';
import { breakpointMdSmall } from '@/components/pages/about/comm/lib/custom-breakpoint.service';
import { body03, body03Medium } from '@/components/pages/about/styles/typography';
import { breakpointMedium } from '@/constants/breakpoints';
import { colors } from '@/constants/colors';

type Props = {
  descriptions: { label: string, content: React.ReactNode }[],
};

const LevelDescription = ({ descriptions }: Props) => {
  return (
    <Container>
      {descriptions.map(({ label, content }) => (
        <Item key={label}>
          <Label>{label}</Label>
          <Content>{content}</Content>
        </Item>
      ))}
    </Container>
  );
};

export default LevelDescription;

const Container = styled.div`
display: flex;
flex-direction: column;
align-self: stretch;
padding: 32px 24px;
background-color: ${colors.uiBackground};
gap: 10px;

@media (max-width: ${breakpointMedium}) {
  padding: 24px;
}

@media (max-width: ${breakpointMdSmall}) {
  padding: 16px;
}
`;

const Item = styled.div`
display: flex;
`;

const Label = styled.span`
${body03Medium}

width: 80px;
flex-shrink: 0;
color: ${colors.primary};
`;

const Content = styled.div`
${body03}

color: ${colors.textBody};
`;
